import { render } from "./PriceBlueBox.vue?vue&type=template&id=4a18a5e4"
import script from "./PriceBlueBox.vue?vue&type=script&lang=js"
export * from "./PriceBlueBox.vue?vue&type=script&lang=js"

import "./PriceBlueBox.vue?vue&type=style&index=0&id=4a18a5e4&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__